/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import AuthorsList from "../../../../arrow-components/src/components/Rows/AuthorsList";
import { awaitHelper } from "../../../utils";
import get from "lodash/get";
import PropTypes from "prop-types";
import "./authors-list.module.css";

export const AuthorsListComponent = (props = {}) => {
  const mountAtPrefix = useSelector(state => get(state, ["qt", "config", "mountAt"], ""));
  const pbConfig = get(props, ["config"], {});
  const initialLoadCount = get(pbConfig, ["initialLoadCount"], 9);
  const subsequentLoadCount = get(pbConfig, ["subsequentLoadCount"], 9);

  let [authorsData, handleAuthorsData] = useState([]);
  const [hideLoadMore, handleLoadMore] = useState(false);
  const [limit, handleLimit] = useState(initialLoadCount);
  const [offset, handleOffset] = useState(initialLoadCount);

  const loadInitialData = async () => {
    const authorsApi = `${mountAtPrefix}/api/v1/authors?limit=${initialLoadCount}`;
    const { data } = await awaitHelper((await fetch(authorsApi)).json());
    return data.authors;
  };

  useEffect(() => {
    authorsData.length < 1 && loadInitialData().then(authors => handleAuthorsData(authors));
  }, []);

  const fetchData = async offset => {
    const authorsApi = `${mountAtPrefix}/api/v1/authors?offset=${offset}&limit=${subsequentLoadCount}`;
    const { data } = await awaitHelper((await fetch(authorsApi)).json());
    const { authors } = data || {};
    handleAuthorsData([...authorsData, ...authors]);
    (authors === [] || authors.length < subsequentLoadCount) && handleLoadMore(!hideLoadMore);
    handleLimit(limit + subsequentLoadCount);
  };

  const getLoadMore = () => {
    fetchData(offset);
    handleOffset(offset + subsequentLoadCount);
  };

  const authorConfig = {
    ...pbConfig,
    buttonText: "Load More"
  };
  return (
    <div styleName="authors-wrapper">
      <AuthorsList
        data={authorsData}
        config={authorConfig}
        getMoreData={getLoadMore}
        hideLoadmore={hideLoadMore}
        limit={limit}
      />
    </div>
  );
};

AuthorsListComponent.propTypes = {
  config: PropTypes.object
};
